import { useMemo } from 'react';

import { SourceOfWealthStatus } from '@shared/api/@types/compliance';
import { FiatIdEnum, ReverificationStatusEnum } from '@shared/enums';
import { UserStore } from '@shared/store';

import { useGetSourceOfWealthStatus } from 'src/lib/verification/hooks/useGetSourceOfWealth';

import { ErrorType } from '../components/EducationPage/ErrorBanner/types/errorBannerTypes';

const useLoansRestrictionBanner = () => {
  const {
    isKyc1Complete,
    isKyc1Required,
    isKyc2Required,
    getReverificationStatus,
    isRestricted,
    userProfile,
    userCountryCurrency,
    isEntity,
  } = UserStore.useUserStore;

  const { status: kyc2Status } = useGetSourceOfWealthStatus();

  const errorType = useMemo((): ErrorType | undefined => {
    if (userCountryCurrency !== FiatIdEnum.AUD) {
      return ErrorType.nonAuUser;
    }
    if (isEntity()) {
      return ErrorType.entityType;
    }
    if (!userProfile?.address || !userProfile.address.streetName || !userProfile.address.suburb) {
      return ErrorType.invalidAddress;
    }
    if (!isKyc1Complete() || isKyc1Required()) {
      return ErrorType.kyc1;
    }
    if (
      userProfile &&
      (getReverificationStatus(userProfile) === ReverificationStatusEnum.REQUESTED ||
        getReverificationStatus(userProfile) === ReverificationStatusEnum.IN_PROGRESS)
    ) {
      return ErrorType.reverificationReq;
    }
    if (
      userProfile &&
      (getReverificationStatus(userProfile) === ReverificationStatusEnum.FAILED ||
        getReverificationStatus(userProfile) === ReverificationStatusEnum.LAPSED)
    ) {
      return ErrorType.reverificationLapsed;
    }
    if (isKyc2Required()) {
      return ErrorType.kyc2Req;
    }
    if (kyc2Status === SourceOfWealthStatus.FAILED) {
      return ErrorType.kyc2Lapsed;
    }
    if (isRestricted()) {
      return ErrorType.userRestricted;
    }
    return undefined;
  }, [
    userCountryCurrency,
    isEntity,
    isKyc1Complete,
    isKyc1Required,
    userProfile,
    getReverificationStatus,
    isKyc2Required,
    kyc2Status,
    isRestricted,
  ]);

  return {
    errorType,
  };
};

export { useLoansRestrictionBanner };
